import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=01ad6719&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=01ad6719&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ad6719",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ad6719')) {
      api.createRecord('01ad6719', component.options)
    } else {
      api.reload('01ad6719', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=01ad6719&scoped=true&", function () {
      api.rerender('01ad6719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29cgV3S3TVR0o/JS/comp/CookieBox.vue"
export default component.exports